let total_accounts = 0;
let total_followers = 0;
let temp = 100;
let check = false;

$(document).ready(function() {
    $(".edit-group-btn").click(function(event) {
      $(".user-management-filter-overlay").show();
    });

    $(".edit-group-btn").on("ajax:success", function(event, data, status, xhr) {
      $(".user-management-filter-overlay").hide();
    }).on("ajax:error", function(event, xhr, status, error) {
      $(".user-management-filter-overlay").hide();
    });

    if($('#update_information_form').find("input[type='checkbox']").length > 0){
      $('#update_information_form').submit(function(e){
          checked = false;
          for(let i = 0; i < $('.checkbox').length; i = i + 1){
              if($($('.checkbox')[i]).is(':checked')){
                  checked = true;
                  break;
              }
          }
          if(checked === false){
            return confirm("Are you sure you want to skip group selection?");
          }
      });
    }

    $("#group_name").change(function(){
        name = $(this).val();
        let abbreviation = ""
        if(!!name){
            let name_parts = name.split(' ');
            for(let i = 0; i < name_parts.length; i = i + 1){
                if(!!name_parts[i][0]){
                    abbreviation = abbreviation + name_parts[i][0].toUpperCase();
                }
            }
        }
        $("#group_abbreviation").text(abbreviation)
    });

    $("#group_name").keyup(function(){
        name = $(this).val();
        let abbreviation = ""
        if(!!name){
            let name_parts = name.split(' ');
            for(let i = 0; i < name_parts.length; i = i + 1){
                if(!!name_parts[i][0]){
                    abbreviation = abbreviation + name_parts[i][0].toUpperCase();
                }
            }
        }
        $("#group_abbreviation").text(abbreviation)
    });
});

window.add_group_file_category_callback = function(event){
  event.preventDefault()
  const authenticity_token = $("meta[name='csrf-token']").attr('content');
  if(!!$(event.target).siblings('input').val()){
    const group_id = $(event.target).data().group_id
    $("a[href='#tabs-2']").css("pointer-events","none")
    $.ajax({
      type: "POST",
      url:"/groups/"+group_id+"/file_categories.json",
      data: {
        file_category: {category: $(event.target).siblings('input').val()},
        authenticity_token: authenticity_token
      },
      dataType: "json"
    }).done(function(data){
      const categories_for_group_files = $("#categories-for-group-files").data('file_categories') || {}
      categories_for_group_files[data.id] = data.category
      const clone = $("#categories-for-group-files").clone()
      clone.data('file_categories',categories_for_group_files)
      $("#categories-for-group-files").replaceWith(clone)
      const category_item = $(event.target).parents('.category-item').clone(true)
      category_item.find('input').attr('type','hidden')
      category_item.find('input').addClass("file-category-name")
      category_item.find('input').keyup(edit_group_file_category_callback);
      category_item.find('.file-category-header').text(data.category)
      category_item.find('.file-category-edit').data("category",data.category)
      category_item.find('.file-category-edit').data("id",data.id)
      category_item.find('.file-category-edit').data("group_id",data.group_id)
      category_item.find('.file-category-edit').css("display","block")
      category_item.find('.file-category-header').css("display","block")
      category_item.find('.add-file-category-button').remove()
      category_item.find('.file-category-edit').click(function(){
      	const category_name_element = $(this).siblings('.file-category-name');
      	category_name_element.attr('type','text');
      	category_name_element.siblings('.file-category-edit').css("display","none")
      	category_name_element.siblings('.file-category-header').css("display","none")
      });
      category_item.draggable({revert: true, axis: 'x'})
      $(".edit-group-modal").find(".edit-categories-main-container").append(category_item)
      $(".edit-group-modal").find(".edit-categories-main-container").append("<div class='clearfix'></div>")
      const option = $("<option></option>")
      option.text(data.category)
      option.attr('value',data.id)
      if($(".group-files").find('select').length > 0){
        $(".group-files").find('select').append(option);
        $(".group-files").find('select').trigger("chosen:updated");
      }
      $(".edit-categories-main-container").scrollTop($(".edit-categories-main-container")[0].scrollHeight)
      $(event.target).siblings('input').val('')
      $("a[href='#tabs-2']").css("pointer-events","all")
    }).fail(function(error){
      $("a[href='#tabs-2']").css("pointer-events","all")
    });
  }
  else {
    alert("Category name cannot be blank.")
  }
}

window.remove_group_file_category = function(event,ui){
  const data = $(ui.draggable).find('.file-category-edit').data()
  const group_id = data.group_id
  const id = data.id
  const categories_for_group_files = $("#categories-for-group-files").data('file_categories') || {}
  delete categories_for_group_files[data.id]
  const clone = $("#categories-for-group-files").clone()
  clone.data('file_categories',categories_for_group_files)
  $("#categories-for-group-files").replaceWith(clone)
  if($(".group-files").find('select').length > 0){
    $(".group-files").find('select').find("option[value='"+id+"']").remove();
    $(".group-files").find('select').trigger("chosen:updated");
  }
  if(!!confirm("Are you sure you want to delete this category?")){
    $(ui.draggable).remove()
    $("a[href='#tabs-2']").css("pointer-events","none")
    $.ajax({
      url: "/groups/"+group_id+"/file_categories/"+id+".json",
      method: "DELETE"
    }).done(function(data){
      $("a[href='#tabs-2']").css("pointer-events","all")
    }).fail(function(error){
      $("a[href='#tabs-2']").css("pointer-events","all")
    });
  }
}

window.edit_group_file_category_callback = function(event){
  const authenticity_token = $("meta[name='csrf-token']").attr('content');
	if(!!document.typing_file_category){
    clearTimeout(document.typing_file_category)
  }
  document.typing_file_category = setTimeout(function(){
    	if(!!!$(event.target).val()){
    		$(event.target).val($(event.target).siblings('.file-category-edit').data().category)
    		$(event.target).attr('type','hidden')
    		$(event.target).siblings('.file-category-edit').css("display","block")
    		$(event.target).siblings('.file-category-header').css("display","block")
    		alert("Category name is required")
    		return
    	}
    	else {
    		data = $(event.target).siblings('.file-category-edit').data()
    		data.category = $(event.target).val()
        categories_for_group_files = $("#categories-for-group-files").data('file_categories') || {}
        categories_for_group_files[data.id] = data.category
        clone = $("#categories-for-group-files").clone()
        clone.data('file_categories',categories_for_group_files)
        $("#categories-for-group-files").replaceWith(clone)
        $(event.target).attr('type','hidden')
        $(event.target).siblings('.file-category-header').text(data.category)
        $(event.target).siblings('.file-category-edit').attr("data-category",data.category)
        $(event.target).siblings('.file-category-edit').css("display","block")
        $(event.target).siblings('.file-category-header').css("display","block")
        $(".group-files").find('select').each(function(){
          option = $(this).find("option[value='"+data.id+"']");
          if(option.length > 0){
            option.text(data.category);
          }
          $(this).trigger('chosen:updated')
        });
    		$.ajax({
    			type: "PUT",
    			url:"/groups/"+data.group_id+"/file_categories/"+data.id+".json",
    			data: {
    				file_category: data,
    				authenticity_token: authenticity_token
    			},
    			dataType: "json"
    		}).done(function(data){
          $("a[href='#tabs-2']").css("pointer-events","all")
        }).fail(function(error){
          $("a[href='#tabs-2']").css("pointer-events","all")
        });
    	}
  },500);
}

function group_file_preview(group_id) {
  $($('.img-preview').last()).change(function(event) {
    let file, input, reader;
    $(this).hide();
    $(this).parent().hide();
    input = $(event.currentTarget);
    file = input[0].files[0];
    reader = new FileReader();
    reader.onload = function(e) {
      let image_base64;
      image_base64 = e.target.result;
      const fileLink = $("<a href='#'></a>").text(file.name);
      $('.group-files-list-'+group_id + "> tbody").children().last().find(".group-file-name-cell > .uploaded-group-file-name").empty().append(fileLink);
    };
    reader.readAsDataURL(file);
  });
  $('.img-preview').last().click();
}

window.remove_group_file_fields = function(link) {
  $(link).siblings().val(1);
  $(link).parent().parent().remove();
}

function check_last_group_file(group_id) {
  if ($('.group-files-list-'+group_id).children().last().find('.img-preview').val() === "")
  {
    $('.group-files-list-'+group_id).children().last().remove();
  }
}

window.add_group_file_fields = function(link, association, fields_to_clone, view, group_id) {
  check_last_group_file();

  if (view === 'new') {
    total_accounts++;
  }
  else {
    temp++;
    total_accounts = temp;
  }

  const regexp = new RegExp("new_" + association, "g");
  const fields_to_clone1 = fields_to_clone.replace(regexp, total_accounts);
  const fields_to_clone_element = $(fields_to_clone1)
  const file_categories = $("#categories-for-group-files").data('file_categories')
  if(!!file_categories && file_categories != {}){
    const file_category_ids = Object.keys(file_categories)
    for(let i = 0; i < file_category_ids.length; i = i + 1){
      const category_id = file_category_ids[i]
      const category_name = file_categories[category_id]
      const category_option_tag = fields_to_clone_element.find("option[value='"+category_id+"']")
      if(category_option_tag.length == 0){
        let option = $('<option></option>')
        option.attr('value',category_id)
        option.text(category_name)
        fields_to_clone_element.find('select').append(option)
      } else {
        category_option_tag.text(category_name)
      }
    }
  } else {
    fields_to_clone_element.find('select').remove("option[value!='']")
  }

  $('.group-files-list-' + group_id).find('tbody').append(fields_to_clone_element);
  $('.group-files-list-' + group_id).find('tbody').find('select').chosen({
    allow_single_deselect: true,
    no_results_text: 'No results matched',
    width: '100%'
  });
  group_file_preview(group_id);
}

window.add_group_follower_fields = function(link, association, fields_to_clone, view) {
  if (view === 'new')
  {
    total_followers++;
  } else
  {
    temp++;
    total_followers = temp;
  }
  let regexp = new RegExp("new_" + association, "g");
  $(link).parent().parent().parent().parent().prepend(fields_to_clone.replace(regexp, total_followers));
  $(function () {
    return $('select.chosen-select').chosen({
      allow_single_deselect: true,
      no_results_text: 'No results matched',
      width: '100%'
    });
  });
}
